import { BaseHTMLForm } from "mixs/base/form_html_mixin";
import { BaseTag } from "mixs/base/base_mixin";

import { save, destroy }    from "apps/actions/common";
class FormCreate extends BaseHTMLForm {
  validFunction = null;
  submitFunction = save;
  files: Array<any> = [];
  public onChangeName(e){

  }
  public onChangeFile(e){
    for(let i=0;i<e.target.files.length;i++){
      let file = e.target.files[i];
      let name = file.name;
      this.files.push(
        { filename: name, file: file, index: i }
      );
    }
    this.update()
    const fileInputs = this.querySelectorAll('.file-input');
    for(let i=0;i<fileInputs.length;i++){
      const fileInput = fileInputs[i] as HTMLInputElement;
      let list = new DataTransfer();
      list.items.add(this.files[i].file);
      fileInput.files = list.files;
    }
  }
}
class FormDestroy extends BaseHTMLForm {
  validFunction = null;
  submitFunction = destroy;
  hasChecked = false;
  public onClick(e){
    let checked = false
    const checkboxies = this.querySelectorAll('input[type="checkbox"]');
    for (var i = 0; i < checkboxies.length; i++) {
      const checkbox = checkboxies[i] as HTMLInputElement;
      if (checkbox.checked) { checked = true }
    }
    this.hasChecked = checked
  }
}
class Files extends BaseTag {

}
riot.mixin('forms.orders.files.create', FormCreate as riot.TagMixin)
riot.mixin('forms.orders.files.destroy', FormDestroy as riot.TagMixin)
riot.mixin('forms.orders.files', Files as riot.TagMixin)
